module.exports = __webpack_public_path__ + "img/tenderpass.d1c67477.png";